import { useEffect, useRef } from 'react';

export default function Sobre() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.15 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" ref={sectionRef} className="bg-[#0A0A0A] py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
          {/* Text Content */}
          <div className="flex-1 reveal opacity-0 translate-y-8 transition-all duration-700">
            <p className="text-[#A3B18A] font-['Montserrat'] text-xs tracking-[4px] uppercase mb-5">
              Sobre Nós
            </p>
            <h2 className="font-['Montserrat'] font-bold text-3xl md:text-4xl lg:text-[48px] text-white leading-[1.15] mb-8">
              Design, técnica<br />
              <span className="text-[#A3B18A]">e experiência</span>
            </h2>
            <div className="space-y-5 max-w-[580px]">
              <p className="font-['Montserrat'] text-[#EDEDED]/85 text-base md:text-[17px] leading-[1.85]">
                Há 20 anos, o escritório desenvolve projetos arquitetônicos para residências, edifícios, conjuntos residenciais e comerciais. A equipe, formada pelos arquitetos André Marés de Souza, Claudia Roth e Cibele Pierrard, atua de forma próxima em todas as etapas do processo, do estudo inicial ao desenvolvimento técnico do projeto, com atuação principal em Curitiba, região metropolitana e litoral do Paraná.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="w-full lg:w-[560px] xl:w-[620px] reveal opacity-0 translate-x-8 transition-all duration-700 delay-200">
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '3/2' }}>
              <img
                src="https://storage.readdy-site.link/project_files/28d65720-7fe8-4426-a837-52846cb570f9/6a11e7c4-9ed7-4651-892f-cf6ebce7a0da_EQUIPE-MARES.png?v=5ba8cf27bbf11be4ebd79f28322ced4e"
                alt="Equipe André Mares Arquitetura"
                className="w-full h-full object-cover object-center grayscale hover:grayscale-0 transition-all duration-700"
              />
              {/* Decorative border */}
              <div className="absolute inset-0 border border-[#A3B18A]/20 rounded-2xl pointer-events-none" />
              {/* Corner accent */}
              <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-[#A3B18A]/60 rounded-br-2xl" />
              <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-[#A3B18A]/60 rounded-tl-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
